import { appStore, supportStore, useStores } from '../../stores';
import { Faqs } from '../../pages/Settings';
import { SupportController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { string, object } from 'yup';

const FaqsContainer = ({ closeModal }) => {
	const [faq, setFaq] = useState(false);

	const {
		appStore: { loading },
		supportStore,
	} = useStores();

	const faqs = supportStore.faqs;
	const showFaq = () => {
		setFaq(true);
	};

	const validationSchema = () =>
		object({
			title: string().required('Title is required'),
			message: string().required('Message is required'),
		});

	const [category, setCategory] = useState('');
	const showCategory = i => {
		if (category === i) {
			return setCategory(' ');
		} else {
			setCategory(i);
		}
	};

	return (
		<Faqs
			closeModal={closeModal}
			faq={faq}
			loading={loading}
			showFaq={showFaq}
			validationSchema={validationSchema}
			faqData={supportStore.faqs}
			category={category}
			showCategory={showCategory}
			faqData2={faqs}
		/>
	);
};

export default observer(FaqsContainer);
